// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2U-V8","infoBtn":"quickbooks_infoBtn__1htdL","formBox":"quickbooks_formBox__2ATCD","formFooter":"quickbooks_formFooter__15qdW"};